import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { BenefitsBrandsResponse, BenefitsResponse, BenefitsStatesResponse, BenefitsAdditionalInfoResponse, BenefitsSearchResponse } from '../models/benefits-response';

@Injectable({
  providedIn: 'root',
})
export class BenefitsService {

  private readonly baseUrl = environment.apiBaseUrl;
  constructor(private http: HttpClient) { }

  getCategories(): Observable<BenefitsResponse> {
    const token = localStorage.getItem('accessToken') || '';
    const cognitoId = localStorage.getItem('cognito') || '';
    const url = `${this.baseUrl}/benefits/${cognitoId}/categories`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `${token}`,
    });
    return this.http.get<BenefitsResponse>(url,{ headers });
  }

  getBenefitsBrands(): Observable<BenefitsBrandsResponse> {
    const token = localStorage.getItem('accessToken') || '';
    const cognitoId = localStorage.getItem('cognito') || '';
    const url = `${this.baseUrl}/benefits/${cognitoId}/brands`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `${token}`,
    });
    return this.http.get<BenefitsBrandsResponse>(url,{ headers });
  }

  getStates(): Observable<BenefitsStatesResponse> {
    const token = localStorage.getItem('accessToken') || '';
    const cognitoId = localStorage.getItem('cognito') || '';
    const url = `${this.baseUrl}/benefits/${cognitoId}/states`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `${token}`,
    });
    return this.http.get<BenefitsStatesResponse>(url, { headers });
  }

  getSucursales(idBrand: number): Observable<BenefitsAdditionalInfoResponse> {
    const token = localStorage.getItem('accessToken') || '';
    const cognitoId = localStorage.getItem('cognito') || '';
    const url = `${this.baseUrl}/benefits/${cognitoId}/additionalInfo`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `${token}`,
    });
    const body = {
      identifier: {
        tenants: 'adff7f6a-e97d-11eb-9a03-0242ac130003',
        app: 'PortalAsistencia'
      },
      petition: {
        id_brand: idBrand,
        name: 'lista_marcas_suc'
      }
    };
    return this.http.post<BenefitsAdditionalInfoResponse>(url, body, { headers });
  }

  searchBenefits(searchParams: {
    id_brand?: number;
    state?: string;
    id_category?: number;
  }): Observable<BenefitsSearchResponse> {
    const token = localStorage.getItem('accessToken') || '';
    const cognitoId = localStorage.getItem('cognito') || '';
    const url = `${this.baseUrl}/benefits/${cognitoId}/searcher`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `${token}`,
    });
    
    const body = {
      identifier: {
        tenants: 'adff7f6a-e97d-11eb-9a03-0242ac130003',
        app: 'PortalAsistencia'
      },
      petition: {
        name: 'lista_marcas',
        ...searchParams
      }
    };
    
    return this.http.post<BenefitsSearchResponse>(url, body, { headers });
  }
}
